export const PRIORITY_LEVELS = [
  { label: 'Критический', from: 9, to: 10, bgColor: 'rgba(255, 205, 210, 0.4)' },
  { label: 'Высокий', from: 7, to: 8, bgColor: 'rgba(255, 224, 178, 0.5)' },
  { label: 'Средний', from: 5, to: 6, bgColor: 'rgba(187, 222, 251, 0.4)' },
  { label: 'Низкий', from: 3, to: 4, bgColor: 'rgba(200, 230, 201, 0.4)' },
  { label: 'Неприоритетно', from: 1, to: 2, bgColor: 'rgba(245, 245, 245, 0.8)' }
];

export function getPriorityMetaByValue(priority) {
  const value = priority === null || priority === undefined || priority === '' ? null : Number(priority);
  if (value === null || Number.isNaN(value)) return null;
  return PRIORITY_LEVELS.find((level) => value >= level.from && value <= level.to) || null;
}

export function getPriorityMetaByRange(priorityFrom, priorityTo) {
  const from = priorityFrom === null || priorityFrom === undefined || priorityFrom === '' ? null : Number(priorityFrom);
  const to = priorityTo === null || priorityTo === undefined || priorityTo === '' ? null : Number(priorityTo);
  if (from === null || to === null || Number.isNaN(from) || Number.isNaN(to)) return null;
  return PRIORITY_LEVELS.find((level) => level.from === from && level.to === to) || null;
}
